export async function loadImage(url) {
	const image = new Image();

	return new Promise((resolve, reject) => {
		image.addEventListener("load", () => resolve(image));
		image.addEventListener("error", e => reject(e));
		image.src = url;
	});
}

export const ready = new Promise(resolve => {
	if (document.readyState !== "loading") return resolve();
	document.addEventListener("DOMContentLoaded", resolve);
});
